
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { COLORS } from "../../constants"
import ProgressBar from "@ramonak/react-progress-bar";
import axios from "axios"
import styled from "styled-components"
import ResultsCard from "./components/ResultsCard"
import { useHistory } from "react-router-dom"
import { CustomButton } from "../../components"
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;


export default function TryAgain() {
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();
    const user = useSelector(state => state.auth.user.user)
    const [tryLevels, setTryLevels] = useState([])
    const [bucketCapacity, setBucketCapacity] = useState(0)
    const [bucketCapacityPercents, setBucketCapacityPercents] = useState(0)
    const totalCapacity = 20;

    useEffect(() => {
        axios.get(`${api}/ts/cp_retry_levels/${user.pupil_id}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data.data;
            setTryLevels(result);

        }).catch(error => {
            alert('Something went wrong, try to reload a page or submit a complaint using button in bottom right corner.')
        });

    }, [])
    useEffect(async () => {
        const response = await axios.get(`${api}/ts/cp_retry_capacity/${user.pupil_id}`);
        const data = await response.data;

        let percents = Math.round(data.total_questions * 100 / totalCapacity);
        setBucketCapacity(data.total_questions);
        setBucketCapacityPercents(percents);


    }, [])

    return (
        <div>
            <div className="d-flex justify-content-between">
                <h6 className="mb-0">Bucket Capacity</h6>
                <div className="flex-grow-1 ml-2">
                    <ProgressBar completed={bucketCapacityPercents} isLabelVisible={false} bgcolor={COLORS.green} labelColor={COLORS.text_dark_green} />

                </div>
                <h6 className="mb-0 ml-2"><span className="color-darker-green">{bucketCapacity}</span> of <span className="color-text-dark-green">20</span> Words</h6>
            </div>
            {tryLevels.length == 0 ?

                <h5 className="text-center color-text-grey mt-5">Zone is empty</h5>


                :
                <StyledCardContainer>
                    {tryLevels.map((level, i) => {
                        return <div className="game-results-grid-card" key={i}>
                            <ResultsCard textcolor={colors[level.level_no - 1].color} bgcolor={colors[level.level_no - 1].bgColor} cardHeight="200px" content={level.level_no} circleWidth="60px">
                                <div className="color-text-grey mt-2 mb-1">{level.questions} {level.questions == 1 ? "Word" : "Words"}</div>
                                <CustomButton className="px-3 py-0" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} onClick={() => history.replace(`/try_again_game/${level.level_no}`)}>
                                    Let's Go
                            </CustomButton>
                            </ResultsCard>
                        </div>
                    })}
                </StyledCardContainer>

            }
        </div>
    )
}
